module.exports = __webpack_public_path__ + "static/media/SAINT_4532.b9f5bc83.jpg";